import PropTypes from "prop-types";

/** First-time register column `p` — keys used by RegisterFormColumn + sections (Phase 13). */
export const registerFormColumnPShape = {
  userType: PropTypes.string,
  registrationStep: PropTypes.number,
  setRegistrationStep: PropTypes.func,
  corporateContacts: PropTypes.array,
  guestReferralSource: PropTypes.string,
  setGuestReferralSource: PropTypes.func,
  guestReferralName: PropTypes.string,
  setGuestReferralName: PropTypes.func,
  formData: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    businessName: PropTypes.string,
    business_name: PropTypes.string,
    phone: PropTypes.string,
    phoneNumber: PropTypes.string,
    dateOfBirth: PropTypes.string,
    address: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
    position: PropTypes.string,
    is_corporate_pg: PropTypes.bool,
  }),
  lawFirmData: PropTypes.shape({
    lawFirm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lawFirmLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  allLawFirms: PropTypes.array,
  filteredLawFirms: PropTypes.array,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  lawFirmSearch: PropTypes.string,
  setLawFirmSearch: PropTypes.func,
  loadingLawFirms: PropTypes.bool,
  handleOpenLawFirmDialog: PropTypes.func,
  lawFirmLocations: PropTypes.array,
  loadingLawFirmLocations: PropTypes.bool,
  selectedLawFirmLocation: PropTypes.object,
  lawFirmLocationDialogOpen: PropTypes.bool,
  setLawFirmLocationDialogOpen: PropTypes.func,
  handleInputChange: PropTypes.func,
  validateFirstName: PropTypes.func,
  validateLastName: PropTypes.func,
  validateBusinessName: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  validateDateOfBirth: PropTypes.func,
  handleAddressCallback: PropTypes.func,
  validateAddress: PropTypes.func,
  handleAccountEmailBlur: PropTypes.func,
  validateUsername: PropTypes.func,
  validatePassword: PropTypes.func,
  showPassword: PropTypes.bool,
  handleRegister: PropTypes.func,
  loading: PropTypes.bool,
  contactForm: PropTypes.object,
  setContactForm: PropTypes.func,
  contactErrors: PropTypes.object,
  setContactErrors: PropTypes.func,
  formatPhoneNumber: PropTypes.func,
  handleHeaderBackClick: PropTypes.func,
  handleUserTypeRadioChange: PropTypes.func,
  handleNavigateGuestBond: PropTypes.func,
  handleGuestBackToSelection: PropTypes.func,
  handleLawFirmAutocompleteChange: PropTypes.func,
  handleLawFirmSearchInputChange: PropTypes.func,
  handleSelectLawFirmLocationFromTable: PropTypes.func,
  handlePositionAutocompleteChange: PropTypes.func,
  handleToggleShowPassword: PropTypes.func,
  handleRemoveCorporateContact: PropTypes.func,
  handleAddCorporateContact: PropTypes.func,
  handleFormSecondaryBack: PropTypes.func,
  handleSignInLink: PropTypes.func,
  duplicateEmailCheck: PropTypes.shape({
    existingAccounts: PropTypes.array,
    hasDuplicate: PropTypes.bool,
    checkEmail: PropTypes.func,
    reset: PropTypes.func,
  }),
};
